/**
 * @author rmh
 * 模块说明：采购调整单管理
 */
import { Service } from '@/tools'

export class procurementAdjustmentService<T extends TProcurementStrategy.procurementAdjustment> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(
    url: `${P}/${keyof TProcurementStrategy.procurementAdjustment}`,
    data?: TCommon.Json,
    toast?: string
  ) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：查询采购调整单
   */
  adjust = <K extends T['ApiAdjust']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiAdjust', data)
  }

  /**
   * 模块说明：查询采购调整单详情
   */
  adjustDetail = <K extends T['ApiAdjustDetail']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiAdjustDetail', data)
  }

  /**
   * 模块说明：查询采购调整单商品列表
   */
  adjustCommodity = <K extends T['ApiAdjustCommodity']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiAdjustCommodity', data)
  }

  /**
   * 模块说明：添加调整单
   */
  addAdjust = <K extends T['ApiAddAdjust']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiAddAdjust', data, '操作成功')
  }
}
